import { Component, Input, OnInit,Output,EventEmitter } from '@angular/core';

@Component({
    selector: 'app-labor-view',
    templateUrl: './labor-view.component.html',
    styleUrls: ['./labor-view.component.scss'],
    standalone: false
})
export class LaborViewComponent implements OnInit {
  isShowList:boolean=false;
  selectedData:any;
  constructor() { }

  ngOnInit(): void {
  }

  getDataEventHander(event:any)
  {
    this.selectedData=event;
    this.isShowList=true;
 
  }
}
